import { createContext, useContext, useMemo, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Color } from 'three';
import { SEEDS, SPACE_PALETTE } from './config.js';

const CelestialContext = createContext(null);

export function CelestialProvider({ children, perfTier, visibleGroups }) {
  const uniforms = useRef({ uTime: { value: 0 }, uTier: { value: perfTier.tier } });
  const value = useMemo(
    () => ({
      palette: {
        void: new Color(SPACE_PALETTE.void),
        indigo: new Color(SPACE_PALETTE.armIndigo),
        violet: new Color(SPACE_PALETTE.armViolet),
        dust: new Color(SPACE_PALETTE.dust),
        core: new Color(SPACE_PALETTE.coreWarm),
        nebula: new Color(SPACE_PALETTE.nebulaSubtle),
        star: new Color(SPACE_PALETTE.star),
      },
      seeds: SEEDS,
      uniforms,
      perfTier,
      visibleGroups,
      whitelist: new Set(['hero', 'nebula', 'dust']),
    }),
    [perfTier, visibleGroups],
  );

  useFrame((state) => {
    uniforms.current.uTime.value = state.clock.elapsedTime;
    uniforms.current.uTier.value = perfTier.tier;
  });

  return <CelestialContext.Provider value={value}>{children}</CelestialContext.Provider>;
}

export function useCelestial() {
  const value = useContext(CelestialContext);
  if (!value) throw new Error('useCelestial must be used inside CelestialProvider');
  return value;
}
